import styled from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'

const defaultIconSize = '70px'

const Feature = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
`

Feature.Icon = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--feature-icon-size, ${defaultIconSize});
  height: var(--feature-icon-size, ${defaultIconSize});
  margin-bottom: 30px;

  & > img {
    width: 100%;
    height:100%;
    object-fit: contain;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    margin-bottom: 20px;
  `}

`

Feature.Title = styled.h4`
  font-weight: 400;
  font-size: 24px;
  text-transform: uppercase;
  text-align: center;
  color: #000;
  margin-bottom: 15px;
`

Feature.Text = styled.p`
  font-size: 16px;
  line-height: 160%;
  text-align: center;
  color: #757575;
`

export default Feature
